import { useState, useEffect } from 'react';
import CustomInput from '../../components/CustomInput';
import '../../assets/css/Login.css';
import CustomButton from '../../components/CustomButton';
import loginImage from '../../assets/images/tennis-court.webp';
import { useNavigate } from 'react-router-dom';
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { saveToken, saveUserId, saveUserAuthId, saveLoggedIn, saveIsOnBoarded } from '../../redux/UserDataSlice';
import { useDispatch } from "react-redux";
import { useSearchParams } from 'react-router-dom';


const LogIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const email = params.get('email');
  const pwd = params.get('password');

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  useEffect(() => {
    if (email || pwd) {
      setFormData(prev => ({
        ...prev,
        email: email || prev.email,
        password: pwd || prev.password
      }));
    }
  }, [email, pwd]);





  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let message = '';

    if (name === 'email') {
      const trimmedValue = value.trim();

      if (!trimmedValue) {
        message = 'Email is required';
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(trimmedValue)) {
          message = 'Please enter a valid email address';
        }
      }
    }


    if (name === 'password') {
      if (!value.trim()) {
        message = 'Password is required';
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: message,
    }));
  };

  const validateInputs = () => {
    const newErrors = {};
    const emailValue = formData.email.trim();
    const passwordValue = formData.password.trim();

    if (!emailValue) {
      newErrors.email = 'Email is required';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailValue)) {
        newErrors.email = 'Please enter a valid email address';
      }
    }

    if (!passwordValue) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const onLogInSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!validateInputs()) return;

    setLoading(true);

    try {
      const data = {
        email: formData.email.toLowerCase().trim(),
        password: formData.password,
      };

      const result = await apiHandler({
        url: endpoint.SIGN_IN,
        method: "POST",
        data: data,
      });

      if (result?.data?.accessToken) {
        dispatch(saveToken({ accessToken: result.data.accessToken }));
        dispatch(saveUserId(result.data.userId));
        dispatch(saveUserAuthId(result.data.authId));
        dispatch(saveIsOnBoarded(result.data.isOnboarded));
        dispatch(saveLoggedIn(true));
        toast.success('Login Successful');
        console.log('result?.data?.isOnboarded', result?.data?.isOnboarded, result?.data?.isPreOnboarded,)
        if (result?.data?.isOnboarded) {
          console.log('explore1')
          navigate('/explore');
        } else if (result?.data?.isPreOnboarded) {
          console.log('explore2')
          navigate('/subscription');
        } else {
          console.log('explore3')
          navigate('/personalise');
        }

      } else {
        setFormData(prev => ({
          ...prev,
          password: ''
        }));
        toast.error(result?.data?.user_description || 'Invalid email or password');
      }
    } catch (error) {
      toast.error(error?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const onRegisterNow = () => navigate('/register');
  const onForgetPassword = () => navigate('/forget-password');

  return (
    <>
      <div >
        <img src={loginImage} alt='' className='Image-LogIn' />
      </div>
      <div className='bg-login login-Wrapper'>
        <div className='container'>
          <div className='row cont-log-in-container d-flex justify-content-center align-items-center ' >
            <div className='col-lg-6 co-sm-12 log-In-container'>
              <form className='form-wrapper' onSubmit={onLogInSubmit}>

                <div className='text-start fw-bolder fs-4 sign-up-text ps-3'>Log In</div>
                <div className='input-button-container'>
                  <CustomInput
                    name='email'
                    label="Email"
                    placeholder="Enter your email"
                    type='text'
                    value={formData.email}
                    className={errors.email ? 'input-error' : ''}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                  {errors.email && <div className="text-danger">{errors.email}</div>}
                </div>

                <div className='input-button-container'>
                  <CustomInput
                    name='password'
                    label="Password"
                    placeholder="Password"
                    type='password'
                    value={formData.password}
                    className={errors.password ? 'input-error' : ''}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                  {errors.password && <div className="text-danger">{errors.password}</div>}
                </div>

                <div className='mt-3 text-end'>
                  <span className='forget-pass-text' onClick={onForgetPassword}>Forgot password?</span>
                </div>

                <div className='logIn-button-container text-center'>
                  <CustomButton
                    buttonText={loading ? 'Logging in...' : 'Login'}
                    className={'login-button'}
                    type="submit"
                    disabled={loading}
                  />
                </div>

                {/* <div className="line-wrapper">
                  <div className="line-text">Or</div>
                </div>

                <div className=' logIn-google-btn-wrapper mt-2 ms-3 me-3 d-flex justify-content-center'>
                  <GoogleSignInButton
                    showDefaultButton={true}
                    buttonText="Sign in with Google"
                    customButtonStyle={{ backgroundColor: '#4285f4', color: 'white' }}
                    onSuccess={(data) => console.log('Success:', data)}
                    onError={(error) => console.log('Error:', error)}
                  />
                </div> */}

                <div className='logIn-register-text'>
                  Not a member? <span className='login-reg-now-txt' onClick={onRegisterNow}>Register now</span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogIn;
